function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import { __decorate } from '../../node_modules/tslib/tslib.es6.js';
import { property, target, registerElement, ImpulseElement } from '@ambiki/impulse';
import scrollLock from '../../helpers/scroll_lock.js';

var AwcDialogElement = /*#__PURE__*/function (_ImpulseElement) {
  _inherits(AwcDialogElement, _ImpulseElement);

  var _super = _createSuper(AwcDialogElement);

  function AwcDialogElement() {
    var _this;

    _classCallCheck(this, AwcDialogElement);

    _this = _super.apply(this, arguments);
    /**
     * Whether the dialog is open or not. To make the dialog open by default, set it to `true`.
     */

    _this.open = false;
    /**
     * Whether or not to hide the dialog when clicking outside of its region.
     */

    _this.hideOnOutsideClick = true;
    return _this;
  }
  /**
   * Called when the element is added to the DOM.
   */


  _createClass(AwcDialogElement, [{
    key: "connected",
    value: function connected() {
      if (this.open) {
        this.show();
      }
    }
    /**
     * Called when the element is removed from the DOM.
     */

  }, {
    key: "disconnected",
    value: function disconnected() {
      this.hideWithoutEmitting();
    }
    /**
     * Shows the dialog element.
     */

  }, {
    key: "show",
    value: function show() {
      this.dialog.showModal();
      this.hideOverflow();
      this.open = true;
    }
    /**
     * Hides the dialog element.
     *
     * @example
     * <awc-dialog>
     *   <dialog>
     *     <button type="button" data-action="click->awc-dialog#hide">Close</button>
     *   </dialog>
     * </awc-dialog>
     */

  }, {
    key: "hide",
    value: function hide() {
      this.hideWithoutEmitting();
      this.emit('hidden');
    }
  }, {
    key: "handleClick",
    value: function handleClick(event) {
      if (!this.hideOnOutsideClick || event.defaultPrevented) return;
      var target = event.target; // Only close the top most dialog in the stack.

      if (!(target instanceof HTMLElement) || target !== this.dialog) return;
      var rect = target.getBoundingClientRect();

      if (rect.top <= event.clientY && event.clientY <= rect.top + rect.height && rect.left <= event.clientX && event.clientX <= rect.left + rect.width) {
        return;
      }

      this.hide();
    }
  }, {
    key: "handleKeydown",
    value: function handleKeydown(event) {
      if (event.key === 'Escape') {
        // Avoid parent popovers from being closed.
        event.stopPropagation();
        this.emit('hidden');
      }
    }
  }, {
    key: "hideWithoutEmitting",
    value: function hideWithoutEmitting() {
      var _a;

      if (this.dialog.open) {
        this.dialog.close(); // Closing the parent dialog when nested dialogs are still open will break the UI.

        (_a = this.nestedDialog) === null || _a === void 0 ? void 0 : _a.hide();
      }

      this.showOverflow();
      this.open = false;
    }
  }, {
    key: "hideOverflow",
    value: function hideOverflow() {
      this._scrollLockController = scrollLock(this);
    }
  }, {
    key: "showOverflow",
    value: function showOverflow() {
      var _a;

      (_a = this._scrollLockController) === null || _a === void 0 ? void 0 : _a.abort();
    }
  }, {
    key: "nestedDialog",
    get: function get() {
      return this.querySelector(this.identifier);
    }
  }]);

  return AwcDialogElement;
}(ImpulseElement);

__decorate([property({
  type: Boolean
})], AwcDialogElement.prototype, "open", void 0);

__decorate([property({
  type: Boolean
})], AwcDialogElement.prototype, "hideOnOutsideClick", void 0);

__decorate([target()], AwcDialogElement.prototype, "dialog", void 0);

AwcDialogElement = __decorate([registerElement('awc-dialog')], AwcDialogElement);
var AwcDialogElement$1 = AwcDialogElement;
export { AwcDialogElement$1 as default };